import React from "react";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import workHoursData from "../data/workHoursData";
import { useEffect } from "react";
export default function Header() {
    const { t, i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [isMenuActive, setIsMenuActive] = useState(false);

    const showData = workHoursData.map((el, index) =>
        <div key={index} className="flex items-center justify-between">
            <div>{el.day}</div>
            <div>{el.time}</div>
        </div>
    )

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        setIsOpen(false);
    };

    i18n.on("languageChanged", (lng) => {
        document.documentElement.lang = lng;
        document.documentElement.dir = lng === "ar" ? "rtl" : "ltr";
    });

    const toggleMenu = () => {
        setIsMenuActive(!isMenuActive);
        setIsOpen(false);
    };

    const closeMenu = () => {
        setIsMenuActive(false);
    };

    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const togglePopup = () => {
        setIsPopupOpen(!isPopupOpen);
    };

    const closePopup = () => {
        setIsPopupOpen(false);
    };


    return (
        <header className="relative py-[12px] shadow">
            <div className="container flex items-center justify-between">
                <Link to={"/"}>
                    <img className="w-[70px] h-[70px]" src={require("../../assets/logo/logo.svg").default} alt="" />
                </Link>
                <div className="flex items-center gap-[7px]">
                    <div className="dis-none flex items-center gap-[5px]">
                        <div className="flex items-center gap-[5px]">
                            <div>
                                <div className="relative">
                                    <div
                                        className="w-fit cursor-pointer"
                                        onClick={togglePopup}
                                    >
                                        {/* <Search /> */}
                                        <img className="w-[25px] h-[25px]" src={require("../../assets/icons/search.svg").default} alt="Language" />
                                    </div>
                                </div>
                                {isPopupOpen && (
                                    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                                        <div className="bg-white rounded-[10px] p-[20px] w-[90%] max-w-[500px] shadow-lg">
                                            <div className="flex justify-between items-center mb-[15px]">
                                                <h3 className="text-lg font-bold">Search</h3>
                                                <button
                                                    onClick={closePopup}
                                                    className="text-gray-500 hover:text-gray-700"
                                                >
                                                    ✖
                                                </button>
                                            </div>
                                            <form>
                                                <div className="flex flex-col gap-[10px]">
                                                <input
                                                    type="search"
                                                    placeholder="Search Product"
                                                    className="rounded-[7px] w-full py-[9px] px-[15px] bg-[#f5f5f5] border border-gray-300 outline-0 shadow-[0px_0px_10px_#00000024]"
                                                />
                                                <button type="submit" className="bg-[#017E89] w-fit px-[30px] py-[7px] rounded-[4px] text-white font-bold capitalize">apply</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="d-none relative">
                        <img className="w-[15px] h-[15px] absolute z-10 top-[30%] left-[5%]" src={require("../../assets/icons/search.svg").default} alt="" />
                        <input className="relative py-[8px] px-[40px] outline-none shadow-[0_0_10px_rgba(0,0,0,0.13)] rounded-[4px] relative" type="text" placeholder="Search" />
                    </div>
                    <div className="relative">
                        <button
                            onClick={() => setIsOpen(!isOpen)}
                            className="flex items-center gap-2 p-2 text-[#666666] font-bold rounded-md capitalize"
                        >
                            <img className="w-[25px] h-[25px]" src={require("../../assets/icons/language.svg").default} alt="Language" />
                        </button>
                        {isOpen && (
                            <div className="absolute right-100 right-0 mt-2 w-40 bg-white shadow-lg rounded-md">
                                <div className="py-1">
                                    <button
                                        onClick={() => changeLanguage("en")}
                                        className="w-full text-left px-4 py-2 text-[#666666] hover:bg-gray-200 rounded-t-md"
                                    >
                                        English
                                    </button>
                                    <button
                                        onClick={() => changeLanguage("ar")}
                                        className="w-full text-left px-4 py-2 text-[#666666] hover:bg-gray-200 rounded-b-md"
                                    >
                                        العربية
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                    <button className={`menu ${isMenuActive ? "active" : ""}`} onClick={toggleMenu}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                </div>
            </div>
            {isMenuActive && (
                <nav className="top-[95px] flex flex-col gap-[20px]">
                    <ul className="flex flex-col gap-4">
                        <li>
                            <NavLink
                                to="/"
                                className={({ isActive }) =>
                                    ` ${isActive ? "text-[#017E89] flex items-center justify-between font-bold " : "text-black flex items-center justify-between"} hover:text-[#017E89] font-bold transition duration-500`
                                }
                                onClick={closeMenu}
                            >
                                {t("Home")}
                                <img className="w-[12px] h-[12px]" src={require("../../assets/icons/nav-arrow.svg").default} alt="" />
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/about"
                                className={({ isActive }) =>
                                    ` ${isActive ? "text-[#017E89] flex items-center justify-between font-bold" : "text-black flex items-center justify-between"} hover:text-[#017E89]  font-bold transition duration-500`
                                }
                                onClick={closeMenu}
                            >
                                {t("About us")}
                                <img className="w-[12px] h-[12px]" src={require("../../assets/icons/nav-arrow.svg").default} alt="" />
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/product"
                                className={({ isActive }) =>
                                    ` ${isActive ? "text-[#017E89] flex items-center justify-between font-bold" : "text-black flex items-center justify-between"} hover:text-[#017E89]  font-bold transition duration-500`
                                }
                                onClick={closeMenu}
                            >
                                {t("Products")}
                                <img className="w-[12px] h-[12px]" src={require("../../assets/icons/nav-arrow.svg").default} alt="" />
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/ceo"
                                className={({ isActive }) =>
                                    ` ${isActive ? "text-[#017E89] flex items-center justify-between font-bold" : "text-black flex items-center justify-between"} hover:text-[#017E89]  font-bold transition duration-500`
                                }
                                onClick={closeMenu}
                            >
                                {t("CEO Message")}
                                <img className="w-[12px] h-[12px]" src={require("../../assets/icons/nav-arrow.svg").default} alt="" />
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/news"
                                className={({ isActive }) =>
                                    ` ${isActive ? "text-[#017E89] flex items-center justify-between font-bold" : "text-black flex items-center justify-between"} hover:text-[#017E89]  font-bold transition duration-500`
                                }
                                onClick={closeMenu}
                            >
                                {t("News & Event")}
                                <img className="w-[12px] h-[12px]" src={require("../../assets/icons/nav-arrow.svg").default} alt="" />
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/team"
                                className={({ isActive }) =>
                                    ` ${isActive ? "text-[#017E89] flex items-center justify-between font-bold" : "text-black flex items-center justify-between"} hover:text-[#017E89]  font-bold transition duration-500`
                                }
                                onClick={closeMenu}
                            >
                                {t("Our Team")}
                                <img className="w-[12px] h-[12px]" src={require("../../assets/icons/nav-arrow.svg").default} alt="" />
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/contact"
                                className={({ isActive }) =>
                                    ` ${isActive ? "text-[#017E89] flex items-center justify-between font-bold" : "text-black flex items-center justify-between"} hover:text-[#017E89]  font-bold transition duration-500`
                                }
                                onClick={closeMenu}
                            >
                                {t("Contact us")}
                                <img className="w-[12px] h-[12px]" src={require("../../assets/icons/nav-arrow.svg").default} alt="" />
                            </NavLink>
                        </li>
                    </ul>
                    <div className="h-[2px] w-full bg-[#dcdcdc]"></div>
                    <div className="flex flex-col gap-[15px]">
                        <div className="w-fit border-b-[2px] border-b-[#017E89] text-[#017E89] capitalize font-bold">work hours</div>
                        <div className="flex flex-col gap-[6px]">
                            {showData}
                        </div>
                    </div>
                </nav>
            )
            }
        </header>
    );
}